import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

/**
 * Public-by-default gate. We removed user accounts entirely (info site only).
 * `requireAdmin` is the ONLY remaining check — used for admin-only routes
 * like /admin/school, /admin-login redirects, etc.
 */
export default function Protected({ children, requireAdmin = false, requireSchool = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (!requireAdmin && !requireSchool) {
    // Public: never block, never redirect.
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-checking">
        <div className="eid-card p-6 text-sm text-zinc-400">Prüfe Zugang…</div>
      </div>
    );
  }
  if (requireAdmin && (!user || !user.is_admin)) {
    return <Navigate to="/admin-login" replace state={{ from: location.pathname }} />;
  }
  if (requireSchool && (!user || (!user.is_school && !user.is_admin))) {
    return <Navigate to="/school" replace state={{ from: location.pathname }} />;
  }
  return children;
}
